module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "required": _vm.required
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "Select Locality...",
      "options": _vm.locality.regions,
      "disabled": _vm.disabled,
      "props": {
        label: 'name',
        value: 'name',
        children: 'divisions'
      },
      "size": _vm.size,
      "show-all-levels": _vm.showLevels,
      "filterable": ""
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0307454d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectLocality.vue
// module id = 1390
// module chunks = 0